export default {
    resalesLanding: {
        sentOn: "Lähetetty",
        toggleContact: "Näytä/piilota välittäjän yhteystiedot",
        propertyOffers: "Kohde-ehdotukset",
        openGallery: "Avaa kuvagalleria",
        prevPhoto: "Edellinen kuva",
        nextPhoto: "Seuraava kuva",
        close: "Sulje",
        photo: "Kuva",
        description: "Kuvaus",
        more: "Lisää",
        less: "Vähemmän",
        intFloorSpace: "Asuinpinta-ala",
        build: "Rakennettu ala",
        terrace: "Terassi",
        garden: "Puutarha",
        buildYear: "Rakennusvuosi",
        fees: "Kulut",
        communityFees: "Yhtiövastike",
        basuraTax: "Jätemaksu (Basura)",
        ibiFees: "IBI (kiinteistövero)",
        securityDeposit: "Vakuus",
        perMonth: "/kk",
        perWeek: "/viikko",
        disclaimer: "Vastuuvapauslauseke",
        energyCertificate: "Energiatodistus",
        pending: "Odottaa",
        rating: "Luokitus",
        presentedBy: "Esittelijä",
        propertyDetails: "Kohteen tiedot",
        reference: "Viite",
        referenceShort: "Ref",
        unitUnavailable: "Ei enää saatavilla",
        availableUnits: "Vapaat asunnot ja hinnat",
        availableUnitsShort: "Vapaat asunnot",
        unit: "Asunto",
        type: "Tyyppi",
        floors: "Kerrokset",
        bedrooms: "MH",
        bathrooms: "KH",
        surfaceArea: "Sisätila",
        price: "Hinta",
        status: "Tila",
        unitAvailable: "Vapaa",
        unitReserved: "Varattu",
        unitSold: "Myyty",
        seeMore: "Näytä lisää",
        seeLess: "Näytä vähemmän",
        floor: "Kerros",
        storeys: "Kerroksia",
        keyReady: "Muuttovalmis",
        touristLicence: "Turistilisenssi",
        firstOccupationLicence: "Käyttöönottolupa",
        notKnown: "Ei tiedossa",
        notProvided: "Ei ilmoitettu",
        yes: "Kyllä",
        no: "Ei",
        mortgageAvailable: "Rahoitus mahdollinen",
        guaranteedRental: "Taattu vuokratuotto",
        sellBeforeCompletion: "Sopimuksen siirto ennen valmistumista",
        sellBeforeCompletionYes: "Sallittu",
        sellBeforeCompletionNo: "Ei sallittu",
        sellBeforeCompletionNotProvided: "Ei ilmoitettu",
        reservation: "Varaus",
        contract: "Sopimus",
        construction: "Rakentaminen",
        completion: "Valmistuminen",
        co2: "CO2",
        energyConsumption: "Energiankulutus",
        co2PerYear: "kg CO2/vuosi",
        kwhPerYear: "kWh/vuosi",
        features: "Ominaisuudet",
        viewDetails: "Näytä tiedot",
        hideDetails: "Piilota kohteen tiedot",
        backToResults: "Tulokset",
        viewProperty: "Katso kohde",
        prevProperty: "Edellinen",
        nextProperty: "Seuraava",
        viewAllFeatures: "Näytä kaikki ominaisuudet",
        allFeatures: "Kaikki ominaisuudet",
        infoOnRequest: "Tiedot pyynnöstä",
        tbc: "Ei tiedossa",
        featureCategoryLabels: { pool: "Allas", views: "Näkymät", parking: "Pysäköinti", kitchen: "Keittiö", condition: "Kunto", garden: "Puutarha" },
        featureQualifierFormat: "{value} {category}",
        location: "Sijainti",
        agencyInformation: "Välittäjän tiedot",
        buyingCosts: "Ostokustannukset",
        propertyPrice: "Kohteen hinta:",
        priceNote: "**Hinta ei sisällä veroja eikä ostokustannuksia.",
        estimatedPurchaseCosts: "Arvioidut ostokustannukset:",
        hide: "Piilota",
        showBreakdown: "Näytä ostokustannusten erittely",
        purchaseCostBreakdown: "Ostokustannusten erittely",
        concept: "Erä",
        application: "Peruste",
        rowTransferTax: "ITP (varainsiirtovero, käytetty asunto)",
        rowVat: "ALV (uudiskohde)",
        rowVatLand: "ALV",
        vatApplication: "10 % (4 % tuetussa asuntotuotannossa)",
        rowStampDuty: "Leimavero (AJD)",
        rowNotary: "Notaari",
        rowLandRegistry: "Kiinteistörekisteri",
        officialTariff: "Virallinen taksa",
        costRangeNotePrefix: "*Ostajan kokonaiskustannukset ovat tyypillisesti",
        and: "ja",
        ofPurchasePrice: "kauppahinnasta.",
        costApproxNote: "*Arvioidut ostokustannukset ovat vain suuntaa antavia. Todelliset kustannukset voivat vaihdella kiinteistön ja ostajan olosuhteiden mukaan. Suosittelemme ammattilaisen neuvontaa tarkan laskelman saamiseksi.",
        additionalInformation: "Lisätiedot",
        addInfoDocument: "*Lyhennetty tiedotusasiakirja saatavilla Andalusian asetuksen 218/2005 mukaisesti",
        addInfoNoFees: "*Ostaja ei maksa välityspalkkiota",
        formHeading: "Haluatko tietää lisää hinnoista ja kohteesta?",
        firstName: "Etunimi",
        enterNumber: "Anna numero",
        email: "Sähköposti",
        searchCountry: "Hae maata tai suuntanumeroa",
        noMatches: "Ei osumia",
        consent: "Painiketta napsauttamalla annat suostumuksesi henkilötietojesi käsittelyyn tietosuojakäytännön mukaisesti, mukaan lukien antamiesi tietojen kerääminen, säilyttäminen ja käyttö yhteydenottoa ja tarvittavien tietojen toimittamista varten.",
        send: "Lähetä",
        contactUs: "Ota yhteyttä",
        yourMessage: "Viestisi",
        agreeData: "Suostun antamaan tietoni saadakseni vastauksen tietopyyntööni.",
        agreeContact: "Pyydän tietoja ja suostun siihen, että hankkeesta vastaava yritys tai sen markkinoija ottaa minuun yhteyttä antamillani yhteystiedoilla, jotka luovutan vapaaehtoisesti tähän tarkoitukseen.",
        reject: "Hylkää",
        like: "Tykkää",
        liked: "Tallennettu",
        rejected: "Hylätty",
        offerRejected: "Tarjous hylätty",
        contact: "Yhteystiedot",
        call: "Soita",
        calling: "Soitetaan",
        noPhone: "Puhelinnumeroa ei saatavilla",
        enquirySent: "Yhteydenotto lähetetty — otamme yhteyttä",
        yourDetails: "tietosi",
        respondedTo: "vastattu",
        noProperties: "Ei näytettäviä kohteita.",
        soldOutBody: "Tämän tarjouksen kohteet on myyty tai ne eivät ole enää markkinoilla. Ota yhteyttä välitystoimistoon saadaksesi päivitetyn valikoiman.",
        expiredTitle: "Tämä tarjouslinkki on vanhentunut",
        expiredBody: "Ota yhteyttä välittäjään saadaksesi ajantasaisen linkin näiden kohteiden katseluun.",
        unavailableTitle: "Tarjous ei ole saatavilla",
        unavailableBody: "Tarjouksen lataaminen ei onnistunut. Linkki voi olla virheellinen tai palvelu on tilapäisesti poissa käytöstä — yritä myöhemmin uudelleen tai ota yhteyttä välittäjään.",
    },
    title: "{agencyName}: n ominaisuudet",
    in: "sisään",
    propertiesFound: "löydetyt ominaisuudet",
    toDay: "Tänään",
    days: "päivää",
    week: "Viikko",
    year: "Vuosi",
    month: "Kuukausi",
    prev: "Edellinen",
    next: "Seuraava",
    backToList: "Takaisin luetteloon",
    sorry: "Anteeksi, me",
    cantFind: "ei löydy",
    lookingFor: "etsimäsi sivu ...",
    thankYou: "KIITOS KÄYNNISTÄ SIVUSIVULLA",
    pleaseContact: "Ota yhteys edustajaan saadaksesi uuden URL-osoitteen.",
    ForSale: "ALE",
    ShortTermRental: "Lyhyt vuokra",
    LongTermRental: "Long Rent",
    showMore: "Show More",
    showLess: "Näytä vähemmän",
    price: "Hinta",
    pricePer: "Hinta per",
    built: "Rakenna",
    floorSpace: "Int. lattiatilaa",
    terrace: "Terassi",
    garden: "Puutarha",
    plot: "juoni",
    propTitle: '{subType} {searchType} kohteessa {location}',
    propTitleShort: '{subType} kohteessa {location}',
    notAvailable: "Ei saatavilla",
    notFound: 'Sivua ei löydy',
    emptyProperties: "Ominaisuuksia ei löytynyt, ota yhteyttä edustajaasi saadaksesi lisätietoja.",
    linkExpired: "Tämä linkki on vanhentunut. Ota yhteyttä kiinteistönvälittäjään saadaksesi päivitetyn kiinteistölinkin.",
    newDevelopment: "Uusi kehitys",
    agencyRaiiNo: "Viraston rekisteröintinumero",
    home: {
        verifyYourURLHere: "Vahvista URL-osoitteesi täällä. Voit tehdä tämän kirjautumalla sisään selaimesi WhatsAppiin ja kopioimalla sitten URL-osoitteen WhatsAppista tähän.",
        pasteUrlHere: "Liitä URL tähän",
        verifyUrl: "Vahvista URL",
        whatIsPropertyViewer: "Mikä on Property-Viewer.com?",
        thisIsWebsiteIsUsed: "Kiinteistönvälittäjät käyttävät tätä verkkosivustoa lähettääkseen kiinteistöjä asiakkailleen. Se on sivuston {resalesonlinecom} tuote. Jos olet epävarma, ota yhteyttä agentti, joka lähetti omaisuusluettelon sinulle.",
        howDoesItWork: "Miten se toimii?",
        inThePast: "Aiemmin agentit lähettäisivät PDF-dokumentteja asiakkailleen. Näitä ei kuitenkaan ole helppo tarkastella monissa laitteissa. Siksi loimme {propertyviewercom}, jotta asiakas voi helpommin tarkastella heille lähetettyjä ominaisuuksia.",
        createAShortList: "Asiakaspalvelija luo lyhyen ominaisuuksien luettelon. Kun he jakavat nämä ominaisuudet kanssasi, saat linkin. Napsauttamalla tätä linkkiä näet ominaisuudet."
    },

    list: {
        propertyTitle: "Napsauttamalla tätä voit tarkastella tämän ominaisuuden tietoja"
    },

    searchType: {
        ForSale: "myytävänä",
        ShortTermRental: "lyhytaikaiseen vuokraukseen",
        LongTermRental: "pitkäaikaiseen vuokraukseen",
    },

    rsStatus: {
        Available: "Käytettävissä",
        Listing: "Listaus",
        UnderOffer: "Alla Tarjous",
        SaleAgreed: "Myynti sovittu",
        OffMarket: "Markkinoiden edustalla",
        Sold: "Myyty",
        Rented: "Vuokrata"
    },

    details: {
        average: "keskiarvo",
        averagePricesFor: "Keskimääräiset hinnat kohteelle",
        showFullER: "Näytä täysi",
        thisProperty: "Tämä ominaisuus",
        infoNotAvailable: "Tätä tietoa ei ole saatavilla.",
        feesEnergyRating: "Maksut, energialuokitus",
        fees: "Palkkiot",
        ibiFees: "IBI-palkkiot",
        basuraTax: "Basuravero",
        communityFees: "Yhteisön palkkiot",
        associatedCosts: "Liittyvät kustannukset",
        energyRating: "Energialuokitus",
        securityDeposit: "Vuokravakuus",
        energyCertificate: "Energiasertifikaatti",
        energyCertificatePending: "Energiasertifikaatti odottaa",
        energyConsumption: "energiankulutus",
        co2: "CO₂",
        co2PerYear: "kgCO₂ / m² vuodessa",
        kwhPerYear: "kWh / m² vuodessa",
        other: "Toiset",
        buildYear: "Rakennusvuosi",
        forSale: "Myytävänä",
        sold: "Myyty",
        longTerm: "Pitkäaikainen",
        shortTermHigh: "Lyhytaikainen korkea",
        shortTermLow: "Lyhytaikainen matala",
        allFeatures: "Kaikki ominaisuudet",
        aproxLocation: "Aprox. Sijainti",
        listingAgent: "Listing agent",
        notIncludeExpensesAndTaxes: "El precio no incluye gastos ni tributos. Los gastos adicionales al precio por parte del comprador son: Vivienda nueva/1ª transmisión Impuesto sobre el Valor Añadido (IVA) 10% (o 4% en caso de vivienda protegida); o en el caso de 2ª y/o posteriores transmisiones Impuesto sobre Transmisiones (ITP) según normativa autonómica vigente. Además, la formalización en documento público del contrato de compraventa (escrituras) podrá estar sujeta a AJD (Actos Jurídicos Documentados) según normativa aplicable, así como gastos de inscripción en el Registro y notaría. Información precontractual disponible conforme a la normativa aplicable en la Comunidad Autónoma correspondiente.",
        rentalLicenseRef: "Matkailijan rekisteröintinumero",
        agencyInformation: "Viraston tiedot",
    },
};